import { call, put, takeLatest } from "redux-saga/effects";
import ReportesActions, {
  Types as ReportesTypes
} from "../../stores/reportes/Actions";
import ReportesService from "../../services/reportes/ReportesService";
import ResponseCode from "../../services/ResponseCode";

function* consultarReportes(request) {
  yield put(ReportesActions.consultarReportesLoading());

  try {
    const response = yield call(
      ReportesService.consultarReportes,
      request.payload
    );

    if (
      !response?.respuesta ||
      response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        ReportesActions.consultarReportesFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message
        })
      );
      return;
    }

    if (response?.respuesta?.codigo !== ResponseCode.OK.code) {
      yield put(ReportesActions.consultarReportesFailure(response?.respuesta));
      return;
    }
    yield put(
      ReportesActions.consultarReportesSuccess({
        data: response?.data,
        paginacion: response?.paginacion
      })
    );
  } catch (error) {
    yield put(
      ReportesActions.consultarReportesFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al consultar reportes: " + error.message
      })
    );
  }
}

function* exportarReportesExcel(request) {
  yield put(ReportesActions.exportarReportesExcelLoading());

  try {
    const response = yield call(
      ReportesService.exportarReportes,
      request.payload
    );

    if (!response || response.status !== 200) {
      yield put(
        ReportesActions.exportarReportesExcelFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: `No se pudo descargar el archivo o no existen datos para los criterios de búsqueda ingresados.`
        })
      );
      return;
    }

    const contentDisposition =
      response.headers?.["content-disposition"] ||
      response.headers?.["Content-Disposition"];
    let filename = `reporte precertificaciones.${
      request?.payload.tipo === "excel" ? "xlsx" : "pdf"
    }`;

    if (contentDisposition) {
      const filenameRegex = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i;
      const matches = contentDisposition.match(filenameRegex);
      if (matches) {
        const rawName = matches[1] || matches[2];
        try {
          filename = decodeURIComponent(rawName.replace(/['"]/g, ""));
        } catch (e) {
          filename = rawName.replace(/['"]/g, "");
        }
      }
    }

    const blobData =
      response.data instanceof Blob
        ? response.data
        : new Blob([response.data], {
            type:
              response.headers?.["content-type"] || "application/octet-stream"
          });

    if (typeof window !== "undefined") {
      const url = URL.createObjectURL(blobData);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    yield put(
      ReportesActions.exportarReportesExcelSuccess({
        data: response?.data,
        paginacion: response?.paginacion
      })
    );
  } catch (error) {
    yield put(
      ReportesActions.consultarReportesFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al consultar reportes: " + error.message
      })
    );
  }
}

const exportedArray = [
  takeLatest(ReportesTypes.CONSULTAR_REPORTES, consultarReportes),
  takeLatest(ReportesTypes.EXPORTAR_REPORTES_EXCEL, exportarReportesExcel)
];

export default exportedArray;
